module.exports = __webpack_public_path__ + "img/seminar (42).589b91b0.jpg";